import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "../api";

export default function Projects() {
  const qc = useQueryClient();
  const { data: projeler = [], isLoading } = useQuery({ queryKey: ["admin-projects"], queryFn: async () => (await api.get("/admin/projects")).data });

  const yeni = async () => {
    try {
      const r = await api.post("/admin/projects", { name: "Yeni Proje", status: "yakinda", summary: "", location: "İstanbul" });
      qc.invalidateQueries({ queryKey: ["admin-projects"] });
      toast.success("Proje oluşturuldu");
      window.location.href = `/admin/projeler/${r.data.id}`;
    } catch (e) { toast.error(apiError(e)); }
  };
  const sil = async (id) => {
    if (!window.confirm("Bu proje silinecek (30 gün çöp kutusunda). Onaylıyor musunuz?")) return;
    try { await api.delete(`/admin/projects/${id}`); qc.invalidateQueries({ queryKey: ["admin-projects"] }); toast.success("Silindi"); }
    catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div>
      <div className="a-satir" style={{ justifyContent: "space-between", marginBottom: 18 }}>
        <h1 style={{ fontFamily: "var(--display)", fontSize: 26 }}>Projeler</h1>
        <button className="a-btn bal" onClick={yeni} data-testid="proje-yeni">+ Yeni proje</button>
      </div>
      {isLoading ? <p className="veri">Yükleniyor…</p> : projeler.length === 0 ? (
        <div className="a-bos">Henüz proje eklenmedi. İlk projeyi ekleyin.</div>
      ) : (
        <table className="a-tablo">
          <thead><tr><th>Ad</th><th>Konum</th><th>Durum</th><th>Sıra</th><th></th></tr></thead>
          <tbody>
            {projeler.map((p) => (
              <tr key={p.id} data-testid={`admin-proje-${p.slug}`}>
                <td><Link to={`/admin/projeler/${p.id}`} style={{ fontWeight: 500 }}>{p.name}</Link></td>
                <td>{p.location}</td>
                <td><span className={`a-etiket ${p.status}`}>{p.status}</span></td>
                <td className="sayi">{p.order}</td>
                <td className="a-satir">
                  <Link to={`/admin/projeler/${p.id}`} className="a-btn hayalet kucuk">Düzenle</Link>
                  <button className="a-btn hayalet kucuk" onClick={() => sil(p.id)} data-testid={`proje-sil-${p.slug}`}>Sil</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
